/**
 * API base URL for backend calls. Runtime (window.ENV.API_BASE_URL) wins so the same
 * build can hit the local backend when served by Node with REACT_APP_API_BASE_URL unset.
 * When empty, same-origin is used (local dev).
 */
export function getApiBaseUrl() {
  if (typeof window !== "undefined" && window.ENV && window.ENV.API_BASE_URL !== undefined) {
    const url = window.ENV.API_BASE_URL;
    return typeof url === "string" ? url.replace(/\/$/, "") : "";
  }
  if (typeof process !== "undefined" && process.env && process.env.REACT_APP_API_BASE_URL) {
    const url = process.env.REACT_APP_API_BASE_URL;
    return typeof url === "string" ? url.replace(/\/$/, "") : "";
  }
  return "";
}
